import * as React from 'react'

import { useModelState } from '../../charts-lib'
import { QUOTE_HEADER_ROOT, STATIC_PRICE_SELECTOR } from './constants'

function toggleStaticheader(isReactHeader: boolean) {
  if (isReactHeader) {
    document.querySelector(STATIC_PRICE_SELECTOR)?.classList.add('hidden')
    document.getElementById(QUOTE_HEADER_ROOT)?.classList.remove('hidden')
  } else {
    document.querySelector(STATIC_PRICE_SELECTOR)?.classList.remove('hidden')
    document.getElementById(QUOTE_HEADER_ROOT)?.classList.add('hidden')
  }
}

export function useReplaceStaticHeader(isLoaded: boolean) {
  React.useEffect(() => {
    toggleStaticheader(isLoaded)
  }, [isLoaded])
}

const CHANGE_UPATE_EVENTS = ['change', 'update']
const QUOTE_MODEL_CHANGE_EVENTS = [...CHANGE_UPATE_EVENTS, 'refetch', 'newerData']

export interface HeaderPricesContext {
  prevClose: number
  lastClose: number
  lastTime: number
  lastDate?: number
  afterClose: number
  afterTime: number
}

export function useChartContextPrices(chartLayoutModel: any): HeaderPricesContext | null {
  const chartModel = useModelState(chartLayoutModel?.charts().first(), {
    watchProperties: ['quote'],
    listenOnEvents: CHANGE_UPATE_EVENTS,
  })
  const quoteModel = useModelState(chartModel?.quote() ?? null, {
    watchProperties: ['lastClose', 'prevClose', 'afterClose', 'afterTime'],
    listenOnEvents: QUOTE_MODEL_CHANGE_EVENTS,
  })

  if (!quoteModel) return null

  return {
    prevClose: quoteModel.prevClose,
    lastClose: quoteModel.lastClose,
    lastTime: quoteModel.lastTime,
    lastDate: quoteModel.lastDate,
    afterClose: quoteModel.afterClose,
    afterTime: quoteModel.afterTime,
  }
}
